import { Icon } from '@iconify/react'
import { Link } from 'react-router-dom'
import { useAuth } from '@/auth/useAuth'
import { useBranding } from '@/branding/BrandingProvider'

export function ProfilePage() {
  const { user } = useAuth()
  const { siteName } = useBranding()

  return (
    <div className="min-h-screen bg-slate-50">
      <nav className="bg-white border-b border-slate-100 h-16 flex items-center px-6">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-navy flex items-center justify-center">
            <Icon icon="solar:health-linear" className="text-white text-sm" />
          </div>
          <span className="text-lg font-medium text-navy tracking-tight">{siteName}</span>
        </Link>
      </nav>

      <div className="max-w-2xl mx-auto px-6 py-12">
        <Link to="/account" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-navy mb-6 transition-colors">
          <Icon icon="solar:arrow-left-linear" /> Back to Dashboard
        </Link>

        <h1 className="text-2xl font-medium tracking-tight text-navy mb-8">Profile</h1>

        <div className="bg-white border border-slate-200 rounded-xl p-6 space-y-4">
          <div>
            <label className="text-sm text-slate-400 font-light">Name</label>
            <p className="text-navy font-medium">{user?.name || 'N/A'}</p>
          </div>
          <div>
            <label className="text-sm text-slate-400 font-light">Email</label>
            <p className="text-navy font-medium">{user?.email || 'N/A'}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
